import script from "./KeyboardShortcutsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KeyboardShortcutsModal.vue?vue&type=script&setup=true&lang=js"

import "./KeyboardShortcutsModal.vue?vue&type=style&index=0&id=636952e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-636952e3"]])

export default __exports__